import type {
  CatalogAnimatedWallpaper,
  LoadedAnimatedWallpaper,
  ResolvedAnimatedWallpaperPreview,
  ResolvedAnimatedWallpaperScene,
  WallpaperSeason
} from './animatedWallpaper.types'

export function resolveAnimatedWallpaperScene(
  definition: LoadedAnimatedWallpaper,
  date?: Date,
  seasonOverride?: WallpaperSeason | null
): ResolvedAnimatedWallpaperScene
export function resolveAnimatedWallpaperScene(
  definition: CatalogAnimatedWallpaper,
  date?: Date,
  seasonOverride?: WallpaperSeason | null
): ResolvedAnimatedWallpaperPreview
export function resolveAnimatedWallpaperScene(
  definition: CatalogAnimatedWallpaper | LoadedAnimatedWallpaper,
  date = new Date(),
  seasonOverride?: WallpaperSeason | null
): ResolvedAnimatedWallpaperPreview {
  if (definition.renderer === 'layers') {
    const { poster, thumbnail, backgroundColor, canvas, assetBaseUrl } =
      definition
    return {
      poster,
      thumbnail,
      backgroundColor,
      canvas,
      ...('layers' in definition && { layers: definition.layers }),
      assetBaseUrl,
      key: `${definition.id}:${definition.revision}`
    }
  }
  const month =
    (date.getMonth() + (definition.hemisphere === 'south' ? 6 : 0)) % 12
  const calendarSeason: WallpaperSeason =
    month >= 2 && month <= 4
      ? 'spring'
      : month >= 5 && month <= 7
        ? 'summer'
        : month >= 8 && month <= 10
          ? 'autumn'
          : 'winter'
  const season = seasonOverride ?? calendarSeason
  return {
    ...definition.seasons[season],
    assetBaseUrl: definition.assetBaseUrl,
    key: `${definition.id}:${definition.revision}:${season}`
  }
}
